import {FC, useMemo, useRef} from 'react';
import {Tooltip} from 'components/Tooltip';
import style from './style.module.scss';
import classNames from 'classnames';
import {ShareSocialNetworks} from 'components/ShareSocialNetworks';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {CopyToClipboard} from 'components/CopyToClipboard';

interface IProps {
    labelText?: string;
    link?: string;
    isSocialNetworks?: boolean;
}

export const ShareButton: FC<IProps> = ({
    labelText = 'Кликните, чтобы сохранить ссылку',
    link,
    isSocialNetworks = true,
}) => {
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    const shareLink = useMemo(() => {
        if (link) {
            return link;
        }

        if ('undefined' !== typeof window) {
            return window.location.href;
        }

        return '';
    }, [link]);

    const overlay = (
        <div className={style.overlay}>
            {isSocialNetworks && <ShareSocialNetworks />}
            <div className={style.linkArea}>
                <CopyToClipboard copyText={shareLink} className={style.linkCopyButton}>
                    <Typography variant={'label-14-r'}>{labelText}</Typography>
                </CopyToClipboard>
                <textarea ref={textAreaRef} className={style.textarea} readOnly={true} value={shareLink} />
            </div>
        </div>
    );

    return (
        <div className={classNames(style.wrapper, 'share-button-wrapper')}>
            <Tooltip openOnClick={true} overlay={overlay} place={'bottom-end'} showArrow={false}>
                <button className={style.button}>
                    <Icon icon={'share-rounded'} />
                </button>
            </Tooltip>
        </div>
    );
};
